// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"463":"5f67619d","466":"5b250f59","563":"1077cd38","787":"8fdaaf71"}[chunkId] + ".chunk.js";
};